<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>

<script>
  import { removeWords } from '@/helper'
  import { mapActions, mapState } from 'vuex'
  import { find } from 'lodash'
  import NewsItem from './NewsItem'
  import SearchFilter from './SearchFilter'
  import AppShowMoreLoader from '@/components/ui/AppShowMoreLoader'

  export default {
    name: 'NewsStream',
    components: {
      AppShowMoreLoader,
      SearchFilter,
      NewsItem,
    },
    props: {
      renderFilter: Boolean,
      showActionItems: Boolean,
      title: { type: String, default: null },
      groupId: { type: Number, default: null },
      topicImg: String,
      topicId: { type: Number, default: null },
      type: { type: String, default: null },
      isModule: { type: Boolean, default: false },
      isDashboardPage: { type: Boolean, default: false },
    },
    data() {
      return {
        page: 1,
        showFilter: false,
        sub: null,
        hash: null,
      }
    },
    computed: {
      ...mapState('news', [
        'filterActive',
        'news',
        'pagination',
      ]),
      showTitle() {
        return this.type === 'stream_widget' ? this.title : this.title || this.$t('news.title')
      },
    },
    watch: {
      '$route.query'(value) {
        this.page = value.page || 1

        if (this.filterActive) {
          this.filterNews(this.createParams(this.page))
        } else {
          this.getNews(this.createParams(this.page))
        }
      },
    },
    created() {
      this.sub = this.$store.subscribe(mutation => {
        switch (mutation.type) {
          case 'posts/CREATE_POST':
          case 'posts/DELETE_POST':
            this.getNews(this.createParams(this.page))
            break
          default:
            return false
        }
      })
      this.page = this.$route.query.page || this.page
      this.paginateStream(1, this.page)
      this.hash = this.$route.hash
    },
    beforeDestroy() {
      // unsubscribe subscription
      this.sub()
    },
    methods: {
      ...mapActions('news', [
        'getNews',
        'setFilterActive',
        'filterNews',
      ]),
      onFilter(page = 1) {
        this.setFilterActive()
        if (parseInt(this.$route.query.page) !== parseInt(page)) {
          this.$router.push({ query: { page } })
        } else if (
          this.pagination.last < this.pagination.self &&
          parseInt(this.$route.query.page) !== this.pagination.first
        ) {
          this.$router.push({ query: { page: this.pagination.first } })
        } else {
          this.filterNews(this.createParams(page))
        }
      },
      paginateStream(start, end) {
        const hash = this.$route.hash
        this.getNews(this.createParams(start)).then(_ => {
          if (hash) {
            if (start + 1 <= end) {
              this.paginateStream(start + 1, end)
            } else {
              this.jumpToPosition(hash)
            }
          }
        })
      },
      updateNews(page = 1) {
        this.getNews(this.createParams(page))
      },
      createParams(page) {
        if (this.isDashboardPage) {
          document.querySelector('body').classList.add('page_dashboard')
        }

        const params = {}
        if (this.groupId) {
          params['group_id'] = this.groupId
        }
        if (this.topicId) {
          params['topic_id'] = this.topicId
        }
        params['page'] = page
        return params
      },
      jumpToPosition(postId) {
        // Only do stuff, if hash is in expected structure
        const jumpTrigger = [
          '#jump-',
          '#comments-',
          '#likes-',
        ]

        if (jumpTrigger.some(trigger => postId.includes(trigger))) {
          // WIP - Have not handled the comments pagination secnario but when we have to jump to exact comment then assign arrayIds.join('-') to some variable and pass that in removeWords instead of postId and handle the pagination scenario.
          // Here I am spliting the combination of postId and commentId to have PostId and jumping to post comment only
          const arrayIds = postId.split('-')

          if (arrayIds.length === 4) {
            arrayIds.pop()
            postId = arrayIds.join('-')
          }
          if (
              // If we don't find plain Id in news, we have to paginate and call the function recursively
              !find(this.news, function(newsItem) {
                return newsItem.id === removeWords(postId, jumpTrigger)
              })
            ) {
            if (this.pagination.next) {
              this.getNews(this.createParams(this.pagination.next)).then(_ => {
                this.jumpToPosition(postId)
              })
            }
          } else {
              // Otherwise we jump to item and highlight it if hash is #jump-
            const jumpTriggerDomInterval = setInterval(
                () => {
                  const item = document.querySelector(postId)
                  if (item) {
                    item.scrollIntoView()
                    item.classList.add('highlighted-post')
                    clearInterval(jumpTriggerDomInterval)
                  }
                },
                500,
            )
          }
        }
      },
      triggerEditPost(newsItem) {
        const groupId = newsItem && newsItem.meta && newsItem.meta.group && newsItem.meta.group.id
        const topicId = newsItem && newsItem.meta && newsItem.meta.topic && newsItem.meta.topic.id

        return `${JSON.stringify(newsItem.attachments)}-${JSON.stringify(groupId)}-${JSON.stringify(topicId)}`
      },
    },
  }
</script>
